export default __webpack_public_path__ + "static/media/filter.3317c790.svg";